import type { ReactNode } from 'react';

export const symbol_split_scene: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h180q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H180v520h180q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H180Zm270 50v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v50h270q24 0 42 18t18 42v520q0 24-18 42t-42 18H510v50q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q450-97.25 450-110Zm60-110h270v-520H510v520Zm-330 0v-520 520Zm600 0v-520 520Z"
		/>
	</svg>
);
